import Navbar from '../../components/Navbar';

const Scan = () => {
  return (
    <div>
      <Navbar />
      <h1>Coming Soon!</h1>
    </div>
  );
}

export default Scan;